// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="retention.RollingRetentionChart"></bfg-chart>
    </div>
</div>

<retention-table data="data" get-data-method="get_data_method"></retention-table>
`;
// Exports
module.exports = code;